import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, GOERLI, MOONBEAM, MUMBAI } from "./chains";

const CONTRACTS = {
  [GOERLI]: {
    // Goerli Testnet
    Vault: "0xEF5616750eeE8337E7e84E77Cc066dB78811AAAC",
    Router: "0x717c6C92B592e85A447630658B270fdeE0BC5021",
    VaultReader: "0x0772e957FcCFcDF7f8aDAEE1b874b1DDDd83a986",
    Reader: "0x0088504EEAe8B1A260dacF1f9DdE9FFE234368e1",
    FlpManager: "0xc3B15C60B76D2d08c1f616D36193d2Af1F5A5C38",
    RewardRouter: "0xdc6934373a2050d370f8fDce078fb9255A3F504C",
    RewardReader: "0xEcb552df99bB4D16CcC894cBcD10bE892e2aBFF8",
    NATIVE_TOKEN: "0xc47564a1303Ab4D8706fd70678Bf71A627605D50",
    FLP: "0x58Ec2c320b682bbC0e05fA9f6C943A36feBB46c3",
    FXDX: "0x77F7F57Dcc36A394D66d170bdFD0d94783D19B37",
    ES_FXDX: "0x236AfB12A35e61A2378352fb8d6fF3207954057b",
    BN_FXDX: "0x65dc83514aB9d4F2e896C5a8294b3aa16d4B547F",
    USDF: "0x7F7e822AD72003fde68827cC31806d7F871b621b",
    ES_FXDX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder
    StakedFxdxTracker: "0x4A86668f3F5e38694880Ff6f4d62C8Fc4A5DFA55",
    BonusFxdxTracker: "0x04d8EC2583829A4f594E10Db7792e9CC4cB71256",
    FeeFxdxTracker: "0xCaBA10d0ddC80aAda44379898cA4783Ae698082f",
    StakedFlpTracker: "0xD372550C90C7DD20d44315D3Fd7d36206a2cD28C",
    FeeFlpTracker: "0xcc205E9C99714495902CB5163B5cfB2F315E3A5a",

    StakedFxdxDistributor: "0x945ea206B8eb500A2C52Cb8db110802EDbbBF2Ba",
    StakedFlpDistributor: "0x817226047a76a068F5A540F363F46334A600675f",
    
    FxdxVester: "0xF22f75ce8FC20A3801B9B0203700bb84d8F8caD8",
    FlpVester: "0x1d11bC7549272d2b2FA8137d7a95Da790C5Fa4D7",
    
    OrderBook: "0x0001e6c8c679854de107a0968ABa89A64a1865aC",
    OrderBookReader: "0x7BCfde821734861F4C4F2cE15887d42979DCCe97",
    
    PositionRouter: "0xBeC864A397D6b72D4f1c22Baf300CF6dE4add741",
    PositionManager: "0x5a8F03199BCc888510bae9153D2B6Aa0f0e60Ac7",
    
    // UniswapFxdxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0x6E48076398F3b16fC157AceaE6F8DD74C1d847d8",
    ReferralReader: "0x1DA813ff0591E22224aD6528Eda1084A1d1869AE",
  },
  [ARBITRUM_TESTNET]: {
    // / goerli: {
      //     admin: "0xD5fba05dE4b2d303D03052e8aFbF31a767Bd908e",
      //     priceSender: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      //     positionsKeeper: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      //     orderKeeper: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      //     liquidator: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      //     mintReceiver: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      
      //     // signers
      //     signer1: "0xD5fba05dE4b2d303D03052e8aFbF31a767Bd908e",
      //     signer2: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
      //     signer3: "0xc136B4cb683343f41aC38B730cF45367c2a1786b",
      //     signer4: "0x78351284f83A52b726aeEe6C2ceBBe656124434c",
      //     signer5: "0x9539Aa4a337b0030606D4Bc996074074FA1DCe2d",
      //     signer6: "0x0aadC3f3a906E392B78B42798Be40B8CFBE97451",
      //     signer7: "0x8B9f8C1454Ca00E8c9e23dbb0D79680b86a33C3B",// fake
      //     signer8: "0x074A430A18C4414aa88080f6daA25bCe6AA66B23",// fake
      //     signer9: "0x70193F4E9Df8CFb79ebC47075fd4C3B2fA466ecE",// fake
      
      //     vault: "0xEF5616750eeE8337E7e84E77Cc066dB78811AAAC",
      //     usdf: "0x7F7e822AD72003fde68827cC31806d7F871b621b",
      //     router: "0x717c6C92B592e85A447630658B270fdeE0BC5021",
      //     vaultPriceFeedOld: "0x7103aFadbB3d3b28049B25637c70924328d73Ed8", // not updated
      //     vaultPriceFeed: "0xa4236551dfb0bE6C40e80C3746DBD13a099405b8",
      //     flp: "0x58Ec2c320b682bbC0e05fA9f6C943A36feBB46c3",
      //     flpManager: "0xc3B15C60B76D2d08c1f616D36193d2Af1F5A5C38",
      //     vaultErrorController: "0xd86882B077b3D0c3ac10A22Bd69F364c1FcFce83",
      //     vaultUtils: "0x70029beefe45F5D8308bd06fC6491D8cb34f444f",
      //     orderBook: "0x0001e6c8c679854de107a0968ABa89A64a1865aC",
      //     tokenManager: "0x2A869589412c10227506E19173C5d08A4394948B",
      //     fxdx: "0x77F7F57Dcc36A394D66d170bdFD0d94783D19B37",
      //     esFxdx: "0x236AfB12A35e61A2378352fb8d6fF3207954057b",
      //     positionManager: "0x5a8F03199BCc888510bae9153D2B6Aa0f0e60Ac7",
      //     positionRouter: "0xBeC864A397D6b72D4f1c22Baf300CF6dE4add741",
      //     swapRouter: "0x3561837482bC0e865d4f9E3bBcf857933dFE4CFC",
      //     liquidityRouter: "0x2CC02646C8aE3d4593DaB80e80eC6A2F66d94c20",
      //     referralReader: "0x1DA813ff0591E22224aD6528Eda1084A1d1869AE",
      //     referralStorage: "0x6E48076398F3b16fC157AceaE6F8DD74C1d847d8",
      //     balanceUpdater: "0x0BC64BAc45c4d8fAC6c5E113a1555B5DAb44E8e4",
      //     batchSender: "0x06d4d3BbDCdCA741baD465D8b616172aAbE2a2d8",
      //     orderBookReader: "0x7BCfde821734861F4C4F2cE15887d42979DCCe97",
      //     reader: "0x0088504EEAe8B1A260dacF1f9DdE9FFE234368e1",
      //     rewardReader: "0xEcb552df99bB4D16CcC894cBcD10bE892e2aBFF8",
      //     vaultReaderV1: "0x8C009Dd38E0E40FD9b0451346BE92838f9A4B2cb", // not updated
      //     vaultReader: "0x0772e957FcCFcDF7f8aDAEE1b874b1DDDd83a986",
      //     bnFxdx: "0x65dc83514aB9d4F2e896C5a8294b3aa16d4B547F",
      //     stakedFxdxTracker: "0x4A86668f3F5e38694880Ff6f4d62C8Fc4A5DFA55",
      //     stakedFxdxDistributor: "0x945ea206B8eb500A2C52Cb8db110802EDbbBF2Ba",
      //     bonusFxdxTracker: "0x04d8EC2583829A4f594E10Db7792e9CC4cB71256",
      //     bonusFxdxDistributor: "0xdf29724A01e237a3255ebE1E638ed1BC91908447",
      //     feeFxdxTracker: "0xCaBA10d0ddC80aAda44379898cA4783Ae698082f",
      //     feeFxdxDistributor: "0xCd02BE07bD2DFE574bF6294457184eFA9db8e373",
      //     feeFlpTracker: "0xcc205E9C99714495902CB5163B5cfB2F315E3A5a",
      //     feeFlpDistributor: "0xfa79D668441c95D7069E32eCec229eF648FA3885",
      //     stakedFlpTracker: "0xD372550C90C7DD20d44315D3Fd7d36206a2cD28C",
      //     stakedFlpDistributor: "0x817226047a76a068F5A540F363F46334A600675f",
      //     fxdxVester: "0xF22f75ce8FC20A3801B9B0203700bb84d8F8caD8",
      //     flpVester: "0x1d11bC7549272d2b2FA8137d7a95Da790C5Fa4D7",
      //     rewardRouterV2Old: "0xc7531ad650D0183B63CBeA4b9D6d9A7Cf305f1f9", // no update
      //     rewardRouterV2: "0xdc6934373a2050d370f8fDce078fb9255A3F504C",
      //     stakeManager: "0x628F47cBB126E6F06572052d78850BFA0554674e",
      //     timelock: "0x060d4084EeefFd585CC75487743EBa2D6417B186",
      //     fastPriceEvents: "0xa34245A6CFccD3ae2181F8Ae01C92CBD8fAE4E7C",
      //     fastPriceFeedOld: "0xb6C7381211Ebf909d70259456dd343bDb0A34332", // no update
      //     fastPriceFeed: "0x8CD6C4e422ceefaa2E63ff333160a1fF7a982Bed",
      //     priceFeedTimelock: "0xC2f1F3cdF621E82E8FD34bB4fEe649BeA03125a3",
      //     stakedFlp: "0x4f697c2cc8f8271aB0513DD9C46B7D209826E99c",
      //     flpBalance: "0x056001c957B38d2e8C58E55E0a5148e2310a79c7"
      //   },
      
      //   goerli: {
      //     // https://docs.chain.link/docs/data-feeds/price-feeds/addresses/
      //     btcPriceFeed: { address: "0xA39434A63A52E749F02807ae27335515BA4b07F7" },
      //     ethPriceFeed: { address: "0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e" },
      //     usdtPriceFeed: { address: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7" },
      //     usdcPriceFeed: { address: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7" },
      //     btc: {
      //       name: "btc",
      //       address: "0x889328FC12EDBb9faccE23791F036005bE633e04",
      //       decimals: 18,
      //       priceFeed: "0xA39434A63A52E749F02807ae27335515BA4b07F7",
      //       priceDecimals: 8,
      //       fastPricePrecision: 1000,
      //       maxCumulativeDeltaDiff: 10 * 1000 * 1000,
      //       isStrictStable: false,
      //       tokenWeight: 27000,
      //       minProfitBps: 0,
      //       maxUsdfAmount: 50 * 1000 *1000,
      //       bufferAmount: 450,
      //       isStable: false,
      //       isShortable: true,
      //       maxGlobalShortSize: 30 * 1000 * 1000,
      //     },
      //     eth: {
      //       name: "eth",
      //       address: "0xc47564a1303Ab4D8706fd70678Bf71A627605D50",
      //       decimals: 18,
      //       priceFeed: "0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e",
      //       priceDecimals: 8,
      //       fastPricePrecision: 1000,
      //       maxCumulativeDeltaDiff: 10 * 1000 * 1000,
      //       isStrictStable: false,
      //       tokenWeight: 28000,
      //       minProfitBps: 0,
      //       maxUsdfAmount: 120 * 1000 * 1000,
      //       bufferAmount: 15000,
      //       isStable: false,
      //       isShortable: true,
      //       maxGlobalShortSize: 30 * 1000 * 1000,
      //     },
      //     usdc: {
      //       name: "usdc",
      //       address: "0x290733C49DA29892b23f16d2c33B9694bB9d7d80",
      //       decimals: 18,
      //       priceFeed: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7",
      //       priceDecimals: 8,
      //       isStrictStable: true,
      //       tokenWeight: 32000,
      //       minProfitBps: 0,
      //       maxUsdfAmount: 120 * 1000 * 1000,
      //       bufferAmount: 60 * 1000 * 1000,
      //       isStable: true,
      //       isShortable: false
      //     },
      //     usdt: {
      //       name: "usdt",
      //       address: "0xD9a40366F9432B5ed484CF009d9793E633b54E10",
      //       decimals: 18,
      //       priceFeed: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7",
      //       priceDecimals: 8,
      //       isStrictStable: true,
      //       tokenWeight: 3000,
      //       minProfitBps: 0,
      //       maxUsdfAmount: 10 * 1000 * 1000,
      //       bufferAmount: 4 * 1000 * 1000,
      //       isStable: true,
      //       isShortable: false
      //     },
      //     nativeToken: {
      //       name: "weth",
      //       address: "0xc47564a1303Ab4D8706fd70678Bf71A627605D50",
      //       decimals: 18
      //     }
      //   },
    // arbitrum testnet
    Vault: "0xBc9BC47A7aB63db1E0030dC7B60DDcDe29CF4Ffb",
    Router: "0xe0d4662cdfa2d71477A7DF367d5541421FAC2547",
    VaultReader: "0xFc371E380262536c819D12B9569106bf032cC41c",
    Reader: "0x2E093c70E3A7E4919611d2555dFd8D697d2fC0a1",
    FlpManager: "0xD875d99E09118d2Be80579b9d23E83469077b498",
    RewardRouter: "0x0000000000000000000000000000000000000000",
    RewardReader: "0x0000000000000000000000000000000000000000",
    NATIVE_TOKEN: "0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681",
    FLP: "0xb4f81Fa74e06b5f762A104e47276BA9b2929cb27",
    FXDX: "0x0000000000000000000000000000000000000000",
    ES_FXDX: "0x0000000000000000000000000000000000000000",
    BN_FXDX: "0x0000000000000000000000000000000000000000",
    USDF: "0xBCDCaF67193Bf5C57be08623278fCB69f4cA9e68",
    ES_FXDX_IOU: "0x0000000000000000000000000000000000000000",
    StakedFxdxTracker: "0x0000000000000000000000000000000000000000",
    BonusFxdxTracker: "0x0000000000000000000000000000000000000000",
    FeeFxdxTracker: "0x0000000000000000000000000000000000000000",
    StakedFlpTracker: "0x0000000000000000000000000000000000000000",
    FeeFlpTracker: "0x0000000000000000000000000000000000000000",

    StakedFxdxDistributor: "0x0000000000000000000000000000000000000000",
    StakedFlpDistributor: "0x0000000000000000000000000000000000000000",

    FxdxVester: "0x0000000000000000000000000000000000000000",
    FlpVester: "0x0000000000000000000000000000000000000000",

    OrderBook: "0xebD147E5136879520dDaDf1cA8FBa48050EFf016",
    OrderBookReader: "0xC492c8d82DC576Ad870707bb40EDb63E2026111E",

    PositionRouter: "0xB4bB78cd12B097603e2b55D2556c09C17a5815F8",
    PositionManager: "0x168aDa266c2f10C1F37973B213d6178551030e44",

    // UniswapFxdxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0x0000000000000000000000000000000000000000",
    ReferralReader: "0x0000000000000000000000000000000000000000",
  },
  [ARBITRUM]: {
    // arbitrum mainnet
    Vault: "0x489ee077994B6658eAfA855C308275EAd8097C4A",
    Router: "0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064",
    VaultReader: "0xfebB9f4CAC4cD523598fE1C5771181440143F24A",
    Reader: "0x2b43c90D1B727cEe1Df34925bcd5Ace52Ec37694",
    FlpManager: "0x321F653eED006AD1C29D174e17d96351BDe22649",
    RewardRouter: "0xA906F338CB21815cBc4Bc87ace9e68c87eF8d8F1",
    RewardReader: "0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0",
    NATIVE_TOKEN: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    FLP: "0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258",
    FXDX: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    ES_FXDX: "0xf42Ae1D54fd613C9bb14810b0588FaAa09a426cA",
    BN_FXDX: "0x35247165119B69A40edD5304969560D0ef486921",
    USDF: "0x45096e7aA921f27590f8F19e457794EB09678141",
    ES_FXDX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954",
    StakedFxdxTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    BonusFxdxTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    FeeFxdxTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",
    StakedFlpTracker: "0x1aDDD80E6039594eE970E5872D247bf0414C8903",
    FeeFlpTracker: "0x4e971a87900b931fF39d1Aad67697F49835400b6",

    StakedFxdxDistributor: "0x23208B91A98c7C1CD9FE63085BFf68311494F193",
    StakedFlpDistributor: "0x60519b48ec4183a61ca2B8e37869E675FD203b34",

    FxdxVester: "0x199070DDfd1CFb69173aa2F7e20906F26B363004",
    FlpVester: "0xA75287d2f8b217273E7FCD7E86eF07D33972042E",

    OrderBook: "0x09f77E8A13De9a35a7231028187e9fD5DB8a2ACB",
    OrderBookReader: "0xa27C20A7CF0e1C68C0460706bB674f98F362Bc21",

    PositionRouter: "0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868",
    PositionManager: "0x75E42e6f01baf1D6022bEa862A28774a9f8a4A0C",

    UniswapFxdxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0xe6fab3f0c7199b0d34d7fbe83394fc0e0d06e99d",
    ReferralReader: "0x8Aa382760BCdCe8644C33e6C2D52f6304A76F5c8",
  },
  [AVALANCHE]: {
    // avalanche
    Vault: "0x9ab2De34A33fB459b538c43f251eB825645e8595",
    Router: "0x5F719c2F1095F7B9fc68a68e35B51194f4b6abe8",
    VaultReader: "0x66eC8fc33A26feAEAe156afA3Cb46923651F6f0D",
    Reader: "0x2eFEE1950ededC65De687b40Fd30a7B5f4544aBd",
    FlpManager: "0xe1ae4d4b06A5Fe1fc288f6B4CD72f9F8323B107F",
    RewardRouter: "0x82147C5A7E850eA4E28155DF107F2590fD4ba327",
    RewardReader: "0x04Fc11Bd28763872d143637a7c768bD96E44c1b6",
    NATIVE_TOKEN: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    FLP: "0x01234181085565ed162a948b6a5e88758CD7c7b8",
    FXDX: "0x62edc0692BD897D2295872a9FFCac5425011c661",
    ES_FXDX: "0xFf1489227BbAAC61a9209A08929E4c2a526DdD17",
    BN_FXDX: "0x8087a341D32D445d9aC8aCc9c14F5781E04A26d2",
    USDF: "0xc0253c3cC6aa5Ab407b5795a04c28fB063273894",
    ES_FXDX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedFxdxTracker: "0x2bD10f8E93B3669b6d42E74eEedC65dd1B0a1342",
    BonusFxdxTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    FeeFxdxTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    StakedFlpTracker: "0x9e295B5B976a184B14aD8cd72413aD846C299660",
    FeeFlpTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",

    StakedFxdxDistributor: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    StakedFlpDistributor: "0xDd593Cf40734199afc9207eBe9ffF23dA4Bf7720",

    FxdxVester: "0x472361d3cA5F49c8E633FB50385BfaD1e018b445",
    FlpVester: "0x62331A7Bd1dfB3A7642B7db50B5509E57CA3154A",

    OrderBook: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderBookReader: "0xccFE3E576f8145403d3ce8f3c2f6519Dae40683B",

    PositionRouter: "0xffF6D276Bc37c61A23f06410Dce4A400f66420f8",
    PositionManager: "0xA21B83E579f4315951bA658654c371520BDcB866",

    TraderJoeFxdxAvaxPool: "0x0c91a070f862666bbcce281346be45766d874d98",
    ReferralStorage: "0x827ed045002ecdabeb6e2b0d1604cf5fc3d322f8",
    ReferralReader: "0x505Ce16D3017be7D76a7C2631C0590E71A975083",
  },

  [MOONBEAM]: {
    // MoonBeam
    Vault: "0xD3dDd179093C612d6f6abd48F65090DD008bA321",
    Router: "0xC824cAeA4Bcd3C054FeA78A58ba6D0A52f661792",
    VaultReader: "0x9BC6B9dB96327335480CC4D6F08A7E00a2384477",
    Reader: "0xB48fbc1F71B8E6C459736e59B80e27aFA3a0Ce3F",
    FlpManager: "0x6EEC778670d1b1c82b85271c3bFb4281A3DcCa8d",
    RewardRouter: "0x597bF61B3bC1AE3542c04b7070d24cE0735957c6",
    RewardReader: "0x268DE15eB064C01A0F837330510c755A5081E56c",
    NATIVE_TOKEN: "0x226bD09205A6Aa9374f77e746feB18971A2501a8",
    FLP: "0x779676333543249A741C1afB7f88e6aFB861427d",
    FXDX: "0x9a74dcaf28a9b7B9BB2Ec59F458EC77565A6A8b2",
    ES_FXDX: "0xf596B3c00695d61b4F79477aD522f0cD46F0db25",
    BN_FXDX: "0x576Aa7EE949600939DBB36781cAF1110CB67a7c7",
    USDF: "0xB36A70FE255f56739fE65C26Ae8Fd0edd0DF2E83",
    ES_FXDX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedFxdxTracker: "0xe4a4b754Ead7245F19B82ba346285208fBC6146d",
    BonusFxdxTracker: "0x035564819A51B12De273E0C49517186Cba7f6C87",
    FeeFxdxTracker: "0xDaA78A48C99A23b1c4156F68A6678E97bfF0256F",
    StakedFlpTracker: "0xddb999B022816b774f5dE06B9f0Faf3b79cE2653",
    FeeFlpTracker: "0xA17eea14C82b42aa955d40a1438A31D693652fC7",

    StakedFxdxDistributor: "0xec0fcDE013059191EE2C164d3b1e4782C6aB4F60",
    StakedFlpDistributor: "0x9243e2f252952c4263dE06CDEaA8684DF014D16D",

    FxdxVester: "0xc3Ac168845c8DAbc8ad42B72F42Ebf48eAADf0F5",
    FlpVester: "0x9E87f4F8E6fad3334682Be65960c7ef112F93Aa0",

    OrderBook: "0x804e614b059Cc7fD8326d1B5C2ACc2A884BD3c0E",
    OrderBookReader: "0xbbf78fF7af9beB06D7B5D582dAfE83397D45d891",

    PositionRouter: "0xE939DfE46Eb7f18093BfbAe0dF8d34455893e0Ee",
    PositionManager: "0x6bD37eB049CbCc833AaB5172Ec2F0ce053FCa41c",

    ReferralStorage: "0x97B85d651fc31c877c23A954f851c99372178ad7",
    ReferralReader: "0xBA6eD2156C3e4791b43F98276BDA66B901A0659B",
  },
  [MUMBAI]: {
    // Mumbai
    Vault: "0xde6B3E71B3395f1B2B2393Cd2C68Daeb06E65eDb",
    Router: "0x7834F27dF278765883b420da25450134bF1bAE29",
    VaultReader: "0xb9E4267d575bc75eF2E88Ce1337b0F0610d7E573",
    Reader: "0x5c35eE0471613796453226b1a6056873c9b77925",
    FlpManager: "0xDB17144cCfA71F368A8cB6400B77644BD6797B63",
    RewardRouter: "0xe7001541E3cec70E8a43bDE5E3f9635B6BF44F13",
    RewardReader: "0xF02A64572D7fb4374Aa4C13c755A0Ebe1Ebb14BC",
    NATIVE_TOKEN: "0xd1132715bc3544b2eaF8Bc47CfbD131a0De0252d",
    FLP: "0x9582c7E27a3BBFe76B7B6bb4571F12848CA90627",
    FXDX: "0x859dCAa0cF4Ea034dab7Af0709149027C687423D",
    ES_FXDX: "0xcAE2e8009b8Dd299319F125c568ecb59Cd5F0e99", 
    BN_FXDX: "0x576Aa7EE949600939DBB36781cAF1110CB67a7c7",
    USDF: "0xd6476EF3a78278609d4F07954C9554AF2C201Af4",
    ES_FXDX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedFxdxTracker: "0xfdCA337eDc7c105aCc1352e911A55fD8461ea2bB",
    BonusFxdxTracker: "0x08655705d59508b51794934efc2910d93af53f7e",
    FeeFxdxTracker: "0xf6a8e0E9fA0a2217c8f9f6eEFE586D8513dA22c6",
    StakedFlpTracker: "0xE820154d74eE57e75be772b9bC3c36eE572c7091",
    FeeFlpTracker: "0xbe582b5D01E2E6C712449E72F89d331D25f8Ad0f",


    StakedFxdxDistributor: "0x24A2dfF93E7e145746E225d6D432a1F8E064940C",
    StakedFlpDistributor: "0xf4a0706FffCa0B6B83E4A831426Cf5cFA0c8DDAf",

    FxdxVester: "0xb1704090c322da5715C50b8bdeDb54C8BF35F0F3",
    FlpVester: "0x518eD25DA485737c6A8cAFEA0f8B4a1eBd16F4f0",

    OrderBook: "0xC81E5dD5fe8890D2B3981939bF49d6b4A23a3795",
    OrderBookReader: "0x8660764C715cF7566bEaEe0Af3F640a862a240d0",

    PositionRouter: "0x66CE70b0d8965d1F464524b51cFfa93D959fDA80",
    PositionManager: "0xb5109882e197e116324FDCaCec5e1C5C368a8e18",

    ReferralStorage: "0x49c1Dfb6Ff55BA13753D1BCe57C89B5243bcDe19",
    ReferralReader: "0x57baA3E350EB7330128cC39aC447743FC2DF4580",
  },
};



// mumbai: {
//   admin: "0xD5fba05dE4b2d303D03052e8aFbF31a767Bd908e",
//   priceSender: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
//   positionsKeeper: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
//   orderKeeper: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
//   liquidator: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
//   mintReceiver: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",

//   // signers
//   signer1: "0xD5fba05dE4b2d303D03052e8aFbF31a767Bd908e",
//   signer2: "0x56722AaD3ae80D056cAD0786B378bD1C45896dA2",
//   signer3: "0xc136B4cb683343f41aC38B730cF45367c2a1786b",
//   signer4: "0x78351284f83A52b726aeEe6C2ceBBe656124434c",
//   signer5: "0x9539Aa4a337b0030606D4Bc996074074FA1DCe2d",
//   signer6: "0x0aadC3f3a906E392B78B42798Be40B8CFBE97451",
//   signer7: "0x8B9f8C1454Ca00E8c9e23dbb0D79680b86a33C3B",// fake
//   signer8: "0x074A430A18C4414aa88080f6daA25bCe6AA66B23",// fake
//   signer9: "0x70193F4E9Df8CFb79ebC47075fd4C3B2fA466ecE",// fake

//   vault: "0xde6B3E71B3395f1B2B2393Cd2C68Daeb06E65eDb",
//   usdf: "0xd6476EF3a78278609d4F07954C9554AF2C201Af4",
//   router: "0x7834F27dF278765883b420da25450134bF1bAE29",
//   vaultPriceFeed: "0x87f1d77684C0f883906356468D8fAC516A79973A",
//   flp: "0x9582c7E27a3BBFe76B7B6bb4571F12848CA90627",
//   flpManager: "0xDB17144cCfA71F368A8cB6400B77644BD6797B63",
//   vaultErrorController: "0x10a1bdCea61b1613E53C661292F235Eb536Bc848",
//   vaultUtils: "0x99474B01085c1fFdc65f34688F7b95A808621136",
//   orderBook: "0xC81E5dD5fe8890D2B3981939bF49d6b4A23a3795",
//   tokenManager: "0x66A9b2Cc764B0c5F55D5876F1C6425b6912dAFBf",
//   fxdx: "0x859dCAa0cF4Ea034dab7Af0709149027C687423D",
//   esFxdx: "0xcAE2e8009b8Dd299319F125c568ecb59Cd5F0e99",
//   positionManager: "0xb5109882e197e116324FDCaCec5e1C5C368a8e18",
//   positionRouter: "0x66CE70b0d8965d1F464524b51cFfa93D959fDA80",
//   referralReader: "0x57baA3E350EB7330128cC39aC447743FC2DF4580",
//   referralStorage: "0x49c1Dfb6Ff55BA13753D1BCe57C89B5243bcDe19",
//   balanceUpdater: "0x33E1B30417B1e13842cAf9CA13e8C29A41C47129",
//   batchSender: "0xE519faCeaef5645adD954e1Ca6679dfDdbC4B5b6",
//   orderBookReader: "0x8660764C715cF7566bEaEe0Af3F640a862a240d0",
//   reader: "0x5c35eE0471613796453226b1a6056873c9b77925",
//   rewardReader: "0xF02A64572D7fb4374Aa4C13c755A0Ebe1Ebb14BC",
//   vaultReader: "0xb9E4267d575bc75eF2E88Ce1337b0F0610d7E573",
//   bnFxdx: "0x08655705d59508b51794934efc2910d93af53f7e",
//   stakedFxdxTracker: "0xfdCA337eDc7c105aCc1352e911A55fD8461ea2bB",
//   stakedFxdxDistributor: "0x24A2dfF93E7e145746E225d6D432a1F8E064940C",
//   bonusFxdxTracker: "0x09273c656Ccae7200ff3B8C709B9611A98a70F11",
//   bonusFxdxDistributor: "0xD429F49E49693A3Aa2D2d3134F5a11c19196fbeD",
//   feeFxdxTracker: "0xf6a8e0E9fA0a2217c8f9f6eEFE586D8513dA22c6",
//   feeFxdxDistributor: "0x9627338cF008eA606271F5e49584297D485294E8",
//   feeFlpTracker: "0xbe582b5D01E2E6C712449E72F89d331D25f8Ad0f",
//   feeFlpDistributor: "0x4146EF303c8cc29FfC3Eb42d90A4F39b24814c44",
//   stakedFlpTracker: "0xE820154d74eE57e75be772b9bC3c36eE572c7091",
//   stakedFlpDistributor: "0xf4a0706FffCa0B6B83E4A831426Cf5cFA0c8DDAf",
//   fxdxVester: "0xb1704090c322da5715C50b8bdeDb54C8BF35F0F3",
//   flpVester: "0x518eD25DA485737c6A8cAFEA0f8B4a1eBd16F4f0",
//   rewardRouterV2: "0xe7001541E3cec70E8a43bDE5E3f9635B6BF44F13",
//   stakeManager: "0x1A1B1aCe13e37055c90e10702068919097CEc73A",
//   timelock: "0x31B7C1aF4D163a1E18Ef03803C82BE574d95C3Ad",
//   fastPriceEvents: "0x644Af161B683D62011C187Fa8B32729b02cD807e",
//   fastPriceFeed: "0x3E5baC47075b433FaD727c02C17cE632AF1607DA",
//   priceFeedTimelock: "0xAfa3B3309c89aB10d50A749f58f218009fFb9a94",
//   stakedFlp: "0xc56064DED280532f9eB56335D22e8653711ED8F3",
//   flpBalance: "0xb6851FfBb0851727039D885547bf2e192B16c499"
// },
export function getContract(chainId: number, name: string): string {
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`);
  }

  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`);
  }

  return CONTRACTS[chainId][name];
}
